/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
/**
 * SVG icon component.
 */
export function Heading3({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><path fill="currentColor" d="M1.6 2.5a.6.6 0 1 0-1.2 0v11a.6.6 0 1 0 1.2 0V8.457h6.3V13.5a.6.6 0 1 0 1.2 0v-11a.6.6 0 0 0-1.2 0v4.757H1.6zM11 6.4a.6.6 0 0 0 0 1.2h2.052l-1.476 1.476A.6.6 0 0 0 12 10.1h1a.9.9 0 0 1 .9.9v.75a1.15 1.15 0 1 1-2.3 0v-.25a.6.6 0 0 0-1.2 0v.25a2.35 2.35 0 0 0 4.7 0V11a2.1 2.1 0 0 0-1.691-2.06l1.515-1.516A.6.6 0 0 0 14.5 6.4z" /></svg>;
}
;